<template>
  <div class="modal fade" tabindex="-1" aria-labelledby="popup" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal_wrapper">
        <div class="modal-header border-0">
          <h1 class="modal-title title" id="popup">
            <slot name="header">{{ header }}</slot>
          </h1>
        </div>
        <div class="modal-body">
          <template v-if="editable">
            <slot name="editor">
              <div class="mb-3">
                <textarea class="form-control" v-model="input"></textarea>
              </div>
            </slot>
          </template>

          <template v-else>
            <slot name="body">{{ body ? body : "-" }}</slot>
          </template>
        </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn btn_secondary d-flex align-items-center" data-bs-dismiss="modal">
            <span>{{ $t("utils.close") }}</span>
          </button>
          <button v-if="showButton" type="button" class="btn btn_main d-flex align-items-center" data-bs-dismiss="modal"
            @click="saveData(this.input)">
            <span>{{ buttonText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['save-data'],
  props: {
    header: {
      type: String,
      required: false
    },
    body: {
      type: String,
      required: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    button: {
      type: String,
      required: false
    },
    showButton: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      input: ""
    }
  },
  computed: {
    buttonText() {
      return this.button || this.$t('utils.save'); // provides default value translation
    }
  },
  methods: {
    saveData(input) {
      this.$emit('save-data', input);
      this.input = "";
    },
    setInput(input) {
      this.input = input;
    }
  },
}
</script>


<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.modal_wrapper {
    border-radius: 35px;
    padding: 5px 5px;

}
</style>